import React, { useContext } from 'react'
import { css } from 'emotion'
import { Text, View } from 'oio-react'
import { Link, useLocation } from 'react-router-dom'
import { BackOutline24Icon } from 'assets/icons'
import uiConstants from 'config/constants/ui'
import { useMe } from 'src/graphql/hooks'
import ThemeContext, { Theme } from 'src/libraries/contexts/Theme'
import IconDrawerMenuButton from '../IconDrawerMenuButton'
import IconMessageButton from '../IconMessageButton'
import IconSearchButton from '../IconSearchButton'
import Logo from '../Logo'

const GlobalNavLayoutVertical = () => {
   const theme = useContext(ThemeContext)
   const location = useLocation()
   const backgroundLocation = location?.state?.backgroundLocation
   const { me, isLoggedIn } = useMe()

   return (
      <>
         <Theme
            viewportMarginTop="60px[a-b] 78px[c] 0px[d-f]"
            viewportMarginLeft="0px[a-c] 80px[d-f]"
         />
         <View
            position="fixed"
            display={theme.globalNavIsHidden ? 'none' : 'flex'}
            flexFlow="row[a-c] column[d-f]"
            top="0px"
            left="0px"
            bottom="0px[d-f]"
            height="60px[a-b] 78px[c] auto[d-f]"
            width="100%[a-c] 80px[d-f]"
            justifyContent="space-between"
            alignItems="center"
            paddingVertical="20px[d-f]"
            paddingHorizontal="18px[a] 9vw[b] 6vw[c]"
            backgroundColor={theme.globalNavBackgroundColor || '#fafafa'}
            borderBottom={`1px solid ${theme.globalNavBorderColor}[a-c]`}
            borderRight={`1px solid ${theme.globalNavBorderColor}[d-f]`}
            zIndex={uiConstants.zIndexes.globalNav}>
            <View
               display="flex[a-c] none[d-f]"
               flex="0 0 auto"
               justifyContent="flex-start"
               alignItems="center"
               height="48px">
               <Logo />
               <View width="36px[c-f]" height="36px" />
            </View>
            <View display="none[a-c] block[d-f]">
               <Link to="/">
                  Home
               </Link>
               {backgroundLocation && (
                  <View
                     className={css`
                        cursor: pointer;

                        &:hover {
                           background-color: #eee;
                        }
                     `}
                     display="flex"
                     justifyContent="center"
                     alignItems="center"
                     width="45px"
                     height="45px"
                     paddingTop="3px"
                     borderRadius="50%">
                     <Link to={backgroundLocation}>
                        <BackOutline24Icon color="#666" strokeWidth="2px" />
                     </Link>
                  </View>
               )}
            </View>
            <View
               display="flex"
               justifyContent={isLoggedIn
                  ? 'space-between'
                  : 'space-between[a-c] flex-end[d-f]'
               }
               alignItems="center"
               flexFlow="row[a-c] column[d-f]"
               width="60px[a-c]"
               height="140px[d-f]">
               <IconSearchButton size="20px[a-c] 24px[d-f]" />
               {isLoggedIn && (
                  <>
                     <IconMessageButton
                        display="none[a-c] block[d-f]"
                        size="18px[a-c] 20px[d-f]"
                     />
                     <View display="none[a-c] block[d-f]">
                        <Link to="/profile">
                           <View
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              width="30px"
                              height="30px"
                              borderRadius="50%"
                              backgroundColor="#eee">
                              <Text size="1" weight="bold" color="#666">
                                 {`${me.firstName.charAt(0)}${me.lastName.charAt(0)}`}
                              </Text>
                           </View>
                        </Link>
                     </View>
                  </>
               )}
               <IconDrawerMenuButton display="block[a-c] none[d-f]" />
            </View>
         </View>
      </>
   )
}

export default GlobalNavLayoutVertical
